export const translations = {
  es: {
    common: {
      home: 'Inicio',
      about: 'Nosotros',
      services: 'Servicios',
      faqs: 'Preguntas frecuentes',
      blog: 'Perspectivas',
      contact: 'Contacto',
      homeCrumb: 'Inicio',
      rights: 'Todos los derechos reservados',
      switchToSpanish: 'ES',
      switchToEnglish: 'EN',
      learnMore: 'Conocer más',
      viewServices: 'Ver servicios',
      contactNow: 'Contactar ahora',
      seeProject: 'Explorar proyecto',
      openContact: 'Abrir contacto'
    },
    navbar: {
      home: 'Inicio',
      about: 'Nosotros',
      services: 'Servicios',
      faqs: 'Preguntas frecuentes',
      blog: 'Perspectivas',
      contact: 'Contacto',
      cta: 'Solicitar propuesta'
    },
    pages: {
      about: 'Nosotros',
      services: 'Servicios',
      contact: 'Contacto',
      faqs: 'Preguntas frecuentes',
      blog: 'Perspectivas',
      portfolio: 'Proyectos'
    },
    home: {
      eyebrow: 'Innovación aplicada · Web3 · Tokenización',
      heroTitle: 'Diseñamos proyectos elegantes de tokenización, identidad digital y producto Web3',
      heroText: 'Innovative Horizons desarrolla experiencias corporativas para instituciones, empresas y organizaciones que quieren transformar procesos, credenciales, activos y modelos operativos en soluciones digitales verificables y visualmente sólidas.',
      primaryCta: 'Explorar servicios',
      secondaryCta: 'Conocer la empresa',
      stats: [
        { value: '06', label: 'líneas estratégicas de servicio' },
        { value: 'B2B', label: 'enfoque institucional y empresarial' },
        { value: 'ES / EN', label: 'sitio preparado en ambos idiomas' }
      ],
      servicesTitle: 'Verticales de solución para proyectos con visión real',
      servicesText: 'La propuesta de Innovative Horizons combina diseño, arquitectura, narrativa y tecnología para presentar proyectos con mayor confianza, orden y escalabilidad.',
      processTitle: 'Un enfoque de empresa, no una demo aislada',
      processText: 'Cada proyecto se estructura con claridad conceptual, identidad visual, arquitectura funcional, experiencia de usuario y acompañamiento estratégico.',
      process: [
        { title: 'Estrategia', text: 'Aterrizamos el modelo, el activo o la credencial y definimos la historia correcta del proyecto.' },
        { title: 'Arquitectura', text: 'Diseñamos la estructura documental, operativa y técnica necesaria para escalar.' },
        { title: 'Producto', text: 'Convertimos la solución en una experiencia digital elegante, comprensible y lista para presentar.' }
      ],
      showcaseTitle: 'Sectores que pueden integrarse al modelo',
      showcaseText: 'Agrícola, inmobiliario, académico, infraestructura, identidad digital, credenciales, licenciamiento y otros activos o procesos con valor demostrable.',
      showcaseBadges: ['Agrícola', 'Inmobiliario', 'Académico', 'Infraestructura', 'Documental', 'Web3 corporativo'],
      ctaTitle: 'Llevemos tu idea a una presencia digital elegante y seria',
      ctaText: 'Podemos adaptar esta misma formalidad a tu propuesta comercial, pitch, micrositio de tokenización o experiencia de validación digital.'
    },
    about: {
      subtitle: 'Empresa de innovación digital con enfoque institucional',
      title: 'Innovative Horizons convierte ideas complejas en experiencias claras',
      intro: 'Nuestra empresa integra tecnología, diseño y narrativa estratégica para construir soluciones presentables, verificables y listas para escalar.',
      body: 'Trabajamos con tokenización, credenciales académicas, identidad digital, dApps, smart contracts y arquitectura Web3 para organizaciones que requieren una presentación elegante y funcional, no solo un desarrollo técnico aislado.',
      pillars: [
        { title: 'Formalidad visual', text: 'Construimos una presencia corporativa alineada a la confianza que exige un proyecto de alto nivel.' },
        { title: 'Claridad funcional', text: 'Hacemos que cada flujo y cada página expliquen el valor del proyecto sin confusión.' },
        { title: 'Proyección estratégica', text: 'Pensamos en la empresa, el inversionista, la institución y el usuario final al mismo tiempo.' }
      ],
      timeline: [
        { phase: '01', title: 'Diagnóstico del proyecto', text: 'Identificamos el objetivo, el público y la narrativa correcta para estructurar la solución.' },
        { phase: '02', title: 'Diseño y arquitectura', text: 'Definimos la base visual, la jerarquía del contenido y los módulos funcionales.' },
        { phase: '03', title: 'Implementación', text: 'Desarrollamos la experiencia final con enfoque elegante, bilingüe y corporativo.' }
      ]
    },
    services: {
      subtitle: 'Portafolio de capacidades',
      title: 'Servicios que elevan la presentación y operación del proyecto',
      intro: 'Cada servicio puede vivir como proyecto individual o como parte de una arquitectura más amplia para empresas, instituciones y plataformas.',
      detailTitle: '¿Qué incluye normalmente este servicio?',
      deliverablesTitle: 'Entregables posibles',
      deliverables: ['Definición conceptual', 'Arquitectura de solución', 'Diseño visual y experiencia', 'Ruta de implementación'],
      ctaTitle: 'Cuéntanos qué vertical quieres desarrollar',
      ctaText: 'Podemos comenzar con un micrositio, una propuesta comercial o una experiencia completa dentro del proyecto.'
    },
    contact: {
      pageTitle: 'Contacto',
      pageIntro: 'Compártenos tu idea y abriremos tu correo con el área adecuada para continuar la conversación.',
      formTitle: 'Cuéntanos tu proyecto',
      formSubtitle: 'La estructura del mensaje se arma automáticamente según el servicio seleccionado.',
      service: 'Servicio',
      name: 'Nombre',
      namePlaceholder: 'Tu nombre completo',
      company: 'Empresa / institución',
      companyPlaceholder: 'Nombre de la empresa o institución',
      email: 'Correo',
      emailPlaceholder: 'correo@empresa.com',
      phone: 'Teléfono',
      phonePlaceholder: 'Número de contacto',
      subject: 'Asunto',
      subjectPlaceholder: 'Ejemplo: tokenización inmobiliaria',
      message: 'Proyecto',
      messagePlaceholder: 'Cuéntanos qué quieres construir, qué industria es y qué presencia visual o técnica necesitas.',
      submit: 'Abrir correo',
      asideTitle: 'Cómo podemos ayudarte',
      asidePoints: [
        'Presentación formal para empresas e instituciones.',
        'Arquitectura de páginas en español e inglés.',
        'Diseño de narrativa para tokenización, identidad y Web3.'
      ]
    },
    faqs: {
      subtitle: 'Preguntas clave',
      title: 'Respuestas claras para proyectos de tokenización y experiencia digital'
    },
    faqQuestions: [
      { id: 1, question: '¿Qué tipo de proyectos puede presentar Innovative Horizons?', answer: 'Podemos estructurar presencia digital y narrativa para proyectos agrícolas, inmobiliarios, académicos, documentales, institucionales y productos Web3.' },
      { id: 2, question: '¿La tokenización solo aplica a cripto?', answer: 'No. También puede utilizarse como marco de representación, validación y trazabilidad de activos, credenciales, derechos o procesos.' },
      { id: 3, question: '¿Puedo tener el sitio en español e inglés?', answer: 'Sí. El proyecto puede manejar dos idiomas para presentar una imagen más sólida ante instituciones, aliados o inversionistas internacionales.' },
      { id: 4, question: '¿Pueden trabajar una sola página o todo el ecosistema?', answer: 'Podemos crear desde una landing formal hasta un sitio completo con servicios, detalle de proyectos, contacto y materiales de apoyo.' },
      { id: 5, question: '¿Qué tan personalizable es el diseño?', answer: 'Mucho. El diseño puede adaptarse a tu identidad corporativa, colores, lenguaje, nivel de formalidad y objetivo comercial.' },
      { id: 6, question: '¿Pueden integrarse dApps o módulos Web3?', answer: 'Sí. El sitio puede convivir con paneles, wallets, validación digital o módulos transaccionales según el alcance del proyecto.' }
    ],
    blog: {
      subtitle: 'Narrativa y posicionamiento',
      title: 'Perspectivas que fortalecen la presentación del proyecto',
      intro: 'Estas piezas editoriales ayudan a explicar el valor de la tokenización, la identidad digital y los nuevos modelos de confianza.',
      posts: [
        { title: 'Por qué la tokenización necesita narrativa, no solo tecnología', desc: 'Un proyecto serio debe explicar origen, valor, operación y confianza con lenguaje claro y visual elegante.' },
        { title: 'El futuro de las credenciales verificables para instituciones', desc: 'La validación digital no solo protege documentos: también mejora reputación, movilidad y trazabilidad.' },
        { title: 'Diseño Web3 corporativo: cómo verse profesional sin perder innovación', desc: 'La adopción empresarial requiere interfaces sobrias, comprensibles y alineadas con objetivos reales.' }
      ]
    },
    portfolio: {
      subtitle: 'Casos tipo y enfoques visuales',
      title: 'Modelos de proyecto que pueden presentarse con esta identidad',
      intro: 'La plataforma visual puede adaptarse a verticales distintas sin perder consistencia corporativa.',
      items: [
        { title: 'Tokenización agrícola', desc: 'Micrositios y reportes para producción, trazabilidad, inversión y activos vinculados al sector agro.' },
        { title: 'Tokenización inmobiliaria', desc: 'Presentación elegante de propiedades, participación, validación y estructura documental.' },
        { title: 'Identidad académica', desc: 'Experiencias para universidades, credenciales, microcredenciales y pasaporte del conocimiento.' },
        { title: 'Producto Web3 institucional', desc: 'Portales, dashboards y flujos de contacto que combinan innovación y formalidad empresarial.' }
      ]
    },
    footer: {
      about: 'Soluciones de tokenización, identidad digital, credenciales verificables, dApps y arquitectura Web3 para proyectos institucionales y empresariales.',
      services: 'Servicios',
      contact: 'Contacto',
      requestAdvice: 'Solicitar asesoría',
      viewPortfolio: 'Ver proyectos',
      serviceLinks: [
        { to: '/services', label: 'Portafolio de servicios' },
        { to: '/services/tokenizacion-activos-rwa', label: 'Tokenización de activos' },
        { to: '/services/tokenizacion-academica', label: 'Tokenización académica' },
        { to: '/services/desarrollo-dapps', label: 'Desarrollo de dApps' }
      ]
    }
  },
  en: {
    common: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      faqs: 'FAQs',
      blog: 'Insights',
      contact: 'Contact',
      homeCrumb: 'Home',
      rights: 'All rights reserved',
      switchToSpanish: 'ES',
      switchToEnglish: 'EN',
      learnMore: 'Learn more',
      viewServices: 'View services',
      contactNow: 'Contact now',
      seeProject: 'Explore project',
      openContact: 'Open contact'
    },
    navbar: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      faqs: 'FAQs',
      blog: 'Insights',
      contact: 'Contact',
      cta: 'Request proposal'
    },
    pages: {
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      faqs: 'FAQs',
      blog: 'Insights',
      portfolio: 'Projects'
    },
    home: {
      eyebrow: 'Applied innovation · Web3 · Tokenization',
      heroTitle: 'We design elegant tokenization, digital identity and Web3 product experiences',
      heroText: 'Innovative Horizons develops corporate-grade digital experiences for institutions, companies and organizations that want to transform processes, credentials, assets and operating models into verifiable and visually refined solutions.',
      primaryCta: 'Explore services',
      secondaryCta: 'About the company',
      stats: [
        { value: '06', label: 'strategic service lines' },
        { value: 'B2B', label: 'institutional and enterprise focus' },
        { value: 'ES / EN', label: 'site ready in both languages' }
      ],
      servicesTitle: 'Solution verticals for projects with real vision',
      servicesText: 'The Innovative Horizons proposal combines design, architecture, narrative and technology to present projects with greater trust, order and scalability.',
      processTitle: 'An enterprise approach, not an isolated demo',
      processText: 'Every project is structured through concept clarity, visual identity, functional architecture, user experience and strategic guidance.',
      process: [
        { title: 'Strategy', text: 'We define the model, the asset or the credential and shape the right story for the project.' },
        { title: 'Architecture', text: 'We design the document, operational and technical structure required to scale.' },
        { title: 'Product', text: 'We turn the solution into an elegant, understandable and presentation-ready digital experience.' }
      ],
      showcaseTitle: 'Sectors that fit this model',
      showcaseText: 'Agriculture, real estate, education, infrastructure, digital identity, credentials, licensing and other assets or processes with demonstrable value.',
      showcaseBadges: ['Agriculture', 'Real estate', 'Education', 'Infrastructure', 'Documents', 'Corporate Web3'],
      ctaTitle: 'Let us turn your idea into a serious and elegant digital presence',
      ctaText: 'We can adapt this same level of formality to your commercial proposal, tokenization microsite or digital validation experience.'
    },
    about: {
      subtitle: 'Digital innovation company with institutional focus',
      title: 'Innovative Horizons turns complex ideas into clear experiences',
      intro: 'Our company integrates technology, design and strategic storytelling to build presentable, verifiable and scalable solutions.',
      body: 'We work with tokenization, academic credentials, digital identity, dApps, smart contracts and Web3 architecture for organizations that need an elegant and functional presence, not just isolated technical development.',
      pillars: [
        { title: 'Visual formality', text: 'We build a corporate presence aligned with the trust expected from high-level projects.' },
        { title: 'Functional clarity', text: 'We make every flow and page explain the project value without confusion.' },
        { title: 'Strategic projection', text: 'We think about the company, investor, institution and end user at the same time.' }
      ],
      timeline: [
        { phase: '01', title: 'Project diagnosis', text: 'We identify the objective, audience and the right narrative to structure the solution.' },
        { phase: '02', title: 'Design and architecture', text: 'We define the visual foundation, content hierarchy and functional modules.' },
        { phase: '03', title: 'Implementation', text: 'We deliver the final experience with an elegant, bilingual and corporate approach.' }
      ]
    },
    services: {
      subtitle: 'Capability portfolio',
      title: 'Services that elevate how the project is presented and operated',
      intro: 'Each service can stand on its own or become part of a wider architecture for companies, institutions and platforms.',
      detailTitle: 'What does this service usually include?',
      deliverablesTitle: 'Possible deliverables',
      deliverables: ['Concept definition', 'Solution architecture', 'Visual design and experience', 'Implementation roadmap'],
      ctaTitle: 'Tell us which vertical you want to develop',
      ctaText: 'We can start with a microsite, a commercial presentation or a complete experience within the project.'
    },
    contact: {
      pageTitle: 'Contact',
      pageIntro: 'Share your idea with us and we will open your email client with the right team ready to continue the conversation.',
      formTitle: 'Tell us about your project',
      formSubtitle: 'The message is automatically structured according to the selected service.',
      service: 'Service',
      name: 'Name',
      namePlaceholder: 'Your full name',
      company: 'Company / institution',
      companyPlaceholder: 'Company or institution name',
      email: 'Email',
      emailPlaceholder: 'email@company.com',
      phone: 'Phone',
      phonePlaceholder: 'Contact number',
      subject: 'Subject',
      subjectPlaceholder: 'Example: real estate tokenization',
      message: 'Project',
      messagePlaceholder: 'Tell us what you want to build, the industry, and the visual or technical presence you need.',
      submit: 'Open email',
      asideTitle: 'How we can help',
      asidePoints: [
        'Formal presentation for companies and institutions.',
        'Page architecture in Spanish and English.',
        'Narrative design for tokenization, identity and Web3.'
      ]
    },
    faqs: {
      subtitle: 'Key questions',
      title: 'Clear answers for tokenization and digital experience projects'
    },
    faqQuestions: [
      { id: 1, question: 'What kind of projects can Innovative Horizons present?', answer: 'We can structure digital presence and narrative for agriculture, real estate, education, documentation, institutional initiatives and Web3 products.' },
      { id: 2, question: 'Is tokenization only for crypto?', answer: 'No. It can also be used as a framework for representing, validating and tracking assets, credentials, rights or processes.' },
      { id: 3, question: 'Can the site be available in Spanish and English?', answer: 'Yes. The project can handle both languages to present a stronger image to institutions, partners or international investors.' },
      { id: 4, question: 'Can you build just one page or the whole ecosystem?', answer: 'We can create anything from a formal landing page to a full site with services, project details, contact and support materials.' },
      { id: 5, question: 'How customizable is the design?', answer: 'Highly customizable. The design can adapt to your identity, colors, tone, level of formality and business objective.' },
      { id: 6, question: 'Can dApps or Web3 modules be integrated?', answer: 'Yes. The site can coexist with dashboards, wallets, digital validation or transactional modules according to the scope of the project.' }
    ],
    blog: {
      subtitle: 'Narrative and positioning',
      title: 'Insights that strengthen how the project is presented',
      intro: 'These editorial pieces help explain the value of tokenization, digital identity and new trust models.',
      posts: [
        { title: 'Why tokenization needs narrative, not only technology', desc: 'A serious project must explain origin, value, operations and trust with clear language and elegant visuals.' },
        { title: 'The future of verifiable credentials for institutions', desc: 'Digital validation protects documents and also improves reputation, mobility and traceability.' },
        { title: 'Corporate Web3 design: how to look professional without losing innovation', desc: 'Enterprise adoption requires interfaces that are refined, understandable and aligned with real goals.' }
      ]
    },
    portfolio: {
      subtitle: 'Project models and visual approaches',
      title: 'Project types that can be presented through this identity',
      intro: 'The visual platform can adapt to different verticals without losing corporate consistency.',
      items: [
        { title: 'Agricultural tokenization', desc: 'Microsites and reports for production, traceability, investment and agriculture-linked assets.' },
        { title: 'Real estate tokenization', desc: 'Elegant presentation of properties, participation, validation and document structure.' },
        { title: 'Academic identity', desc: 'Experiences for universities, credentials, micro-credentials and the knowledge passport.' },
        { title: 'Institutional Web3 product', desc: 'Portals, dashboards and contact flows that combine innovation with enterprise-level formality.' }
      ]
    },
    footer: {
      about: 'Tokenization, digital identity, verifiable credentials, dApps and Web3 architecture for institutional and enterprise projects.',
      services: 'Services',
      contact: 'Contact',
      requestAdvice: 'Request advice',
      viewPortfolio: 'View projects',
      serviceLinks: [
        { to: '/services', label: 'Service portfolio' },
        { to: '/services/tokenizacion-activos-rwa', label: 'Asset tokenization' },
        { to: '/services/tokenizacion-academica', label: 'Academic tokenization' },
        { to: '/services/desarrollo-dapps', label: 'dApp development' }
      ]
    }
  }
};
